































import { Component, Vue, Watch } from "vue-property-decorator";
import UploadTeamSurveys from "@/components/team/UploadTeamSurveys.vue";
import { TeamReportData, TeamReportDataBundle } from "@/store/state";
import TeamScoreBarChart from "@/components/team/TeamScoreBarChart.vue";
import TeamScoreDataTable from "@/components/team/TeamScoreDataTable.vue";
import IndividualBreakdown from "@/components/team/IndividualBreakdown.vue";
import { ActionTypes } from "@/store/actions";

@Component({
  components: {
    UploadTeamSurveys,
    TeamScoreBarChart,
    TeamScoreDataTable,
    IndividualBreakdown
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    }
  }
})
export default class Results extends Vue {
  get teamReportDataArray(): TeamReportData[] {
    return this.$store.getters.returnTeamReportDataArray;
  }
  get individualReportDataArray(): TeamReportDataBundle[] {
    return this.$store.getters.returnIndividualTeamReportDataArray;
  }

  @Watch("$i18n.locale")
  changeLanguage(value: string, oldValue: string) {
    //    this.Survey.locale = value;
    //    this.Survey.render();
  }

  get hasReportData(): boolean {
    return this.teamReportDataArray.length > 0;
  }

  get showBreakdown() {
    return this.$store.getters.returnShowBreakdown;
  }

  addTeamReportData(teamReportData: TeamReportData) {
    this.$store.commit(ActionTypes.AddTeamSurvey, teamReportData);
  }
}
